import { render } from "./simpleChart.vue?vue&type=template&id=a3410146"
import script from "./simpleChart.vue?vue&type=script&lang=js"
export * from "./simpleChart.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__